"use client";

import { useState, useRef, useEffect, ReactNode } from "react";
import mainStyle from "../styles/app.module.css";
interface CollapsibleFooterProps {
  children: ReactNode;
}

export default function CollapsibleFooter({
  children,
}: CollapsibleFooterProps) {
  const [showAll, setShowAll] = useState(true);
  const [showButton, setShowButton] = useState(false);
  const [height, setHeight] = useState(0);
  const footerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (footerRef.current) {
      setHeight(footerRef.current.scrollHeight);
      setShowButton(footerRef.current.scrollHeight > 200); // Use fixed value to match maxHeight
    }

    const handleResize = () => {
      if (footerRef.current) {
        setHeight(footerRef.current.scrollHeight);
        setShowButton(footerRef.current.scrollHeight > 200); // Use fixed value to match maxHeight
      }
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <div className={mainStyle.container}>
      <div
        ref={footerRef}
        className="relative overflow-hidden transition-all duration-500"
        style={{ maxHeight: showAll ? `${height}px` : "200px" }}
      >
        {children}

        {/* Gradient overlay inside the content area */}
        {showButton && !showAll && (
          <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-white via-white/80 to-transparent pointer-events-none"></div>
        )}
      </div>

      {/* Button container outside the content and gradient area */}
      {/* <div className="mt-4 sm:mt-6 relative z-20">
        {showButton && (
          <button
            className="text-gray-800 hover:text-black font-semibold text-sm flex items-center cursor-pointer transition-colors"
            onClick={() => setShowAll(!showAll)}
          >
            {showAll ? "Read less" : "Read more"}
          </button>
        )}
      </div> */}
    </div>
  );
}
